import { createContext } from "react";

export const QuizContentContext = createContext([]);